<template>
    <Modal class="tiw__step__chooseDevice">
        <template #header>
            <p class="tiw__h2">
                {{
                    useTranslate(
                        TIWStore.domainIsAvoAfrica || TIWStore.domainIsTakealot
                            ? "tiw__chooseDevice__title__avoAfrica"
                            : "tiw__chooseDevice__title",
                    )
                }}
            </p>
            <p>
                {{
                    useTranslate(
                        TIWStore.domainIsTakealot
                            ? "tiw__chooseDevice__subtitle_takealot"
                            : "tiw__chooseDevice__subtitle",
                    )
                }}
            </p>
        </template>
        <div class="tiw__step__chooseDevice__body">
            <form name="chooseDeviceForm">
                <!-- Поле "Бренд" -->
                <Field class="tiw__field_brand">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__brand") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_brand.value"
                            :options="ChooseDeviceStore.brands"
                            label="name"
                            name="brand"
                            :disabled="loadingToNext"
                        />
                    </template>
                </Field>

                <!-- Поле "Категория" -->
                <Field class="tiw__field_category">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__category") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_category.value"
                            :options="ChooseDeviceStore.field_category.data"
                            name="category"
                            label="name"
                            :disabled="loadingToNext || disabledCategorySelect"
                        />
                    </template>
                </Field>

                <!-- Поле "Модель" -->
                <Field class="tiw__field_model">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__model") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_model.value"
                            :options="ChooseDeviceStore.field_model.data"
                            :is-loading="ChooseDeviceStore.isLoading.model"
                            name="model"
                            label="name"
                            :disabled="loadingToNext || disabledModelSelect"
                        />
                    </template>
                </Field>

                <!-- Поле "Память / Модель / Год" -->
                <Field v-if="!ChooseDeviceStore.isCommercialNotebook" class="tiw__field_other">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__other") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_storage.value"
                            :is-loading="ChooseDeviceStore.isLoading.product"
                            :options="ChooseDeviceStore.field_storage.data"
                            name="other"
                            label="storage"
                            :disabled="loadingToNext || disabledStorageSelect"
                        />
                    </template>
                </Field>

                <!-- Поле "Цвет" -->
                <Field v-if="!ChooseDeviceStore.isCommercialNotebook" class="tiw__field_color">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__color") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_color.value"
                            :options="ChooseDeviceStore.field_color.data"
                            name="color"
                            label="color"
                            :disabled="loadingToNext || disabledColorSelect"
                        />
                    </template>
                </Field>
                <Field v-if="ChooseDeviceStore.isCommercialNotebook" class="tiw__field_color">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__CPU") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_CPU.value"
                            :options="ChooseDeviceStore.field_CPU.data"
                            name="keyShow2"
                            label="keyShow2"
                            :disabled="loadingToNext || disabledCPUSelect"
                            :is-loading="ChooseDeviceStore.isLoading.product"
                        />
                    </template>
                </Field>
                <Field v-if="ChooseDeviceStore.isCommercialNotebook" class="tiw__field_color">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__GPU") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_GPU.value"
                            :options="ChooseDeviceStore.field_GPU.data"
                            name="keyShow3"
                            label="keyShow3"
                            :disabled="loadingToNext || disabledGPUSelect"
                        />
                    </template>
                </Field>
                <Field v-if="ChooseDeviceStore.isCommercialNotebook" class="tiw__field_color">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__RAM") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_RAM.value"
                            :options="ChooseDeviceStore.field_RAM.data"
                            name="keyShow4"
                            label="keyShow4"
                            :disabled="loadingToNext || disabledRAMSelect"
                        />
                    </template>
                </Field>
                <Field v-if="ChooseDeviceStore.isCommercialNotebook" class="tiw__field_color">
                    <template #hintTop>
                        <span>
                            {{ useTranslate("tiw__chooseDevice__Memory") }}
                        </span>
                    </template>
                    <template #body>
                        <Select
                            v-model="ChooseDeviceStore.field_Memory.value"
                            :options="ChooseDeviceStore.field_Memory.data"
                            name="keyShow5"
                            label="keyShow5"
                            :disabled="loadingToNext || disabledMemorySelect"
                        />
                    </template>
                </Field>
            </form>

            <div v-if="showDeviceNotAccepted" class="tiw__step__chooseDevice__deviceNotAccepted">
                <Notification type="danger">
                    {{ useTranslate("tiw__chooseDevice_deviceNotAccepted") }}
                </Notification>
            </div>

            <div id="turnstile-container"></div>

            <Button
                type="button"
                :disabled="!isNextStepButtonEnabled"
                :loading="loadingToNext"
                class="tiw__step__chooseDevice__btn-next tiw__btn-next_manual"
                @click="clickToNext"
            >
                <span>{{ useTranslate("tiw__continue") }}</span>
            </Button>

            <p v-if="terms" class="tiw__text tiw_fs-12 tiw_tc tiw_usn" v-html="terms" />
        </div>
    </Modal>
</template>

<script lang="ts">
export default {
    name: "ChooseDevice",
};
</script>

<script setup lang="ts">
/**
 * * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [ChooseDevice]
 * Модальное окно / экран "Выбор устройства"
 */

import { computed, onBeforeMount, onMounted, ref, watch } from "vue";

import type { I_it4GetStatusQuestion_Return } from "@/hooks/requests/it4GetStatusQuestion/it4GetStatusQuestion.types";

import Modal from "@/components/modal/modal.vue";
import Notification from "@/components/notification/notification.vue";
import { PARTNERS_DOMAINS } from "@/constants";
import { useBugTracker, BugTrackerSection } from "@/helpers/bugTracker";
import { I_AXIOS } from "@/hooks/requests/configRequest.model";
import it4GetStatusQuestion from "@/hooks/requests/it4GetStatusQuestion/it4GetStatusQuestion";
import { useAnalyticsEventPreState } from "@/hooks/useAnalytics/useAnalytics";
import useRegisterProduct from "@/hooks/useRegisterProduct/useRegisterProduct";
import useTradeInCalculation from "@/hooks/useTradeInCalculation/useTradeInCalculation";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useCaptchaStore } from "@/stores/captcha/captcha";
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { useTIWStore } from "@/stores/tiw/tiw";
import Button from "@/ui/button/button.vue";
import Field from "@/ui/field/field.vue";
import Select from "@/ui/select/select.vue";

onBeforeMount(() => {
    captchaStore.addScriptToHTML();
});
onMounted(() => {
    captchaStore.renderCaptcha();
});

const TIWStore = useTIWStore();
const ChooseDeviceStore = useChooseDeviceStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();
const captchaStore = useCaptchaStore();

const loadingToNext = ref<boolean>(false);
const showDeviceNotAccepted = ref<boolean>(false);

watch(
    () => ChooseDeviceStore.deviceChain,
    () => {
        showDeviceNotAccepted.value = false;
    },
    { deep: true },
);

watch(
    computed(() => ChooseDeviceStore.deviceChain.join(", ")),
    () => {
        showDeviceNotAccepted.value = false;
    },
);

const clickToNext = async () => {
    loadingToNext.value = true;

    await useRegisterProduct();

    if (isNaN(parseFloat(HowYouRateDeviceStore.registeringDeviceData?.price))) {
        showDeviceNotAccepted.value = true;
        loadingToNext.value = false;

        // useBugTracker("ChooseDevice - next: price is NaN", BugTrackerSection.ERROR, {
        //     registeringDeviceData: HowYouRateDeviceStore.registeringDeviceData,
        // })

        return;
    }

    if (HowYouRateDeviceStore.registeringDeviceData.canWidgetGrading) {
        // Вопрос для экрана "В каком состоянии ваше устройство?"
        try {
            const StatusQuestionData = await it4GetStatusQuestion({
                deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
                token: TIWStore.WIDGET_DATA.token,
                lang: TIWStore.standardizedLocale,
                from: 3,
            });

            // useBugTracker("ChooseDevice - it4GetStatusQuestion (response)", BugTrackerSection.INFO, {
            //     response: StatusQuestionData,
            // });

            StatusQuestionData.options.forEach((el, ind) => {
                el.imageVariant = `${I_AXIOS.IT4_HOST_PREVIEW}/attach/get2/${el.imgCid}`;
            });

            HowYouRateDeviceStore.questionData = StatusQuestionData;
        } catch (e) {
            useBugTracker("ChooseDevice - it4GetStatusQuestion", BugTrackerSection.ERROR, {
                exception: e.message,
                request: {
                    deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
                    token: TIWStore.WIDGET_DATA.token,
                    lang: TIWStore.standardizedLocale,
                    from: 3,
                },
            });

            loadingToNext.value = false;
            return;
        }

        loadingToNext.value = false;
        TIWStore.switchStep("howYouRateDevice");
        useAnalyticsEventPreState();
    } else {
        HowYouRateDeviceStore.questionData = {
            question: useTranslate("tiw__calculatedDevice__title_pre"),
        } as I_it4GetStatusQuestion_Return["data"];
        HowYouRateDeviceStore.isBack = false;
        HowYouRateDeviceStore.grade = "Q"; // Оцениваем как по максимальному грейду
        HowYouRateDeviceStore.isNoPhotoSet = true;

        useTradeInCalculation();

        loadingToNext.value = false;

        TIWStore.switchStep("howYouRateDevice");
        useAnalyticsEventPreState();
    }
};

// const howFindImeiBlock = ref<boolean>(false);

// const showInfoAboutImei = () => (howFindImeiBlock.value = true);
// const hideInfoAboutImei = () => (howFindImeiBlock.value = false);

const disabledCategorySelect = computed<boolean>(
    (): boolean => !ChooseDeviceStore.field_brand.value,
);
const disabledModelSelect = computed<boolean>(
    (): boolean => !ChooseDeviceStore.field_category.value,
);
const disabledCPUSelect = computed<boolean>((): boolean => !ChooseDeviceStore.field_model.value);
const disabledGPUSelect = computed<boolean>((): boolean => !ChooseDeviceStore.field_CPU.value);
const disabledRAMSelect = computed<boolean>((): boolean => !ChooseDeviceStore.field_GPU.value);
const disabledMemorySelect = computed<boolean>((): boolean => !ChooseDeviceStore.field_RAM.value);
const disabledStorageSelect = computed<boolean>(
    (): boolean => !ChooseDeviceStore.field_model.value,
);
const disabledColorSelect = computed<boolean>(
    (): boolean => !ChooseDeviceStore.field_storage.value,
);

const terms = computed<string>(() => {
    if (TIWStore.locationIsMD) {
        return useTranslate("tiw__chooseDevice__terms__md");
    }

    if (TIWStore.locationIsGE) {
        return useTranslate("tiw__chooseDevice__terms__ge");
    }

    if (TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.FOXTROT) {
        return useTranslate("tiw__chooseDevice__terms__ua_foxtrot");
    }

    if (
        TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.BREEZY_UA ||
        TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.COMFY
    ) {
        return useTranslate("tiw__chooseDevice__terms__ua_breezy");
    }

    if (TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.AVO_AFRICA) {
        return useTranslate("tiw__chooseDevice__terms__za_avo_africa");
    }

    if (TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.TAKEALOT) {
        return useTranslate("tiw__chooseDevice__terms__za_takealot");
    }

    if (TIWStore.INJECTED_TIW.current_settings.domain === PARTNERS_DOMAINS.DG_CO_ZA) {
        return useTranslate("tiw__chooseDevice__terms__za_dg_co");
    }

    return useTranslate("tiw__chooseDevice__terms");
});

const isNextStepButtonEnabled = computed(
    () => ChooseDeviceStore.isAcceptedNext && !loadingToNext.value && captchaStore.isCaptchaSuccess,
);
</script>

<style lang="scss" src="./chooseDevice.scss"></style>
